export const HOME_LANDING_ROUTES = {
  stays: "/home/stays",
  experiences: "/home/experiences",
  explore: "/home/explore",
};

const HOME_LANDING_PATH_MODES = {
  "/": "stays",
  [HOME_LANDING_ROUTES.stays]: "stays",
  [HOME_LANDING_ROUTES.experiences]: "experiences",
  [HOME_LANDING_ROUTES.explore]: "explore",
};

export function normalizeHomeLandingMode(value = "") {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "stay" || raw === "stays") return "stays";
  if (raw === "experience" || raw === "experiences") return "experiences";
  if (raw === "explore" || raw === "explores") return "explore";
  return "";
}

export function resolveHomeLandingModeFromPath(pathname = "") {
  const normalizedPath = String(pathname || "/").replace(/\/+$/, "") || "/";
  return HOME_LANDING_PATH_MODES[normalizedPath] || "";
}

export function resolveHomeLandingRoute(mode = "stays") {
  const normalizedMode = normalizeHomeLandingMode(mode);
  return HOME_LANDING_ROUTES[normalizedMode] || HOME_LANDING_ROUTES.stays;
}

export function isHomeLandingPath(pathname = "") {
  return Boolean(resolveHomeLandingModeFromPath(pathname));
}
